import { gql } from "@apollo/client";

export const PAYOUT_2FA_OFF_MUTATION = gql(`
    mutation OffPTFA($code: String!) {
      offPTFA(tfaCode: $code)
    }
`);
